export const ADD_VOUCHER = 'ADD_VOUCHER';
export const CLEAR_VOUCHER = 'CLEAR_VOUCHER';

export const submitVoucher = (params = {}) => ({
  type: ADD_VOUCHER,
  request: client =>
    client('bff/auth/redeem/gift-voucher', {
      method: 'POST',
      body: params,
    }),
});

export const clearVoucher = () => ({
  type: CLEAR_VOUCHER,
});
